import { useMemo } from "react";
import { useLocation } from "react-router";
import _ from "lodash";

import { URLS } from "config/urls";
import { reverse } from "utils/urls";

import GroupLabel from "components/ButtonDropdown/GroupLabel";
import NavItem from "components/DealPageLayout/SubNavigation/MenuList/NavItem";
import Link from "components/Link";
import { MenuItem } from "components/Menu";

import { useMemos } from "entities/MemoTemplate/sdk";

export interface IMemoMenu {
  dealId: number;
  memoId: number;
}

const MemoMenu = ({ dealId, memoId }: IMemoMenu) => {
  const location = useLocation();

  const { data: memoTemplates = [] } = useMemos({ dealId });
  const orderedMemos = useMemo(
    () => _.orderBy(memoTemplates, ["name"]),
    [memoTemplates]
  );

  return (
    <NavItem
      buttonDataTestid="deal-navigation-memos"
      isActive={location.pathname.indexOf("memo/") > 0}
      label="Memos"
    >
      <GroupLabel label="Memos" />
      {orderedMemos?.map((memo) => (
        <Link
          data-testid="deal-memo-link"
          key={memo.id}
          to={reverse(URLS.DEAL_MEMO, {
            dealId,
            memoId: memo.id,
          })}
        >
          <MenuItem
            selected={memo.id === memoId}
            data-testid="memo-package-name"
          >
            {memo.name}
          </MenuItem>
        </Link>
      ))}

      {_.isEmpty(orderedMemos) && (
        <MenuItem disabled data-testid="empty-package-list">
          No memo templates
        </MenuItem>
      )}
    </NavItem>
  );
};

export default MemoMenu;
